'use client';
import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Home, Map, Bookmark, User, Bell, Settings, LogIn,  } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface SidebarProps {
  currentPath?: string;
}

const NAV_ITEMS = [
  { href: '/', label: 'Beranda', icon: Home },
  { href: '/jelajahi-explore', label: 'Jelajahi', icon: Map },
  { href: '/simpan-saved', label: 'Simpan', icon: Bookmark },
  { href: '/profil-profile-dashboard', label: 'Profil', icon: User },
];

export default function Sidebar({ currentPath = '/' }: SidebarProps) {
  return (
    <aside className="hidden lg:flex flex-col fixed left-0 top-0 h-full w-64 bg-card border-r border-border z-40 py-6 px-4">
      {/* Logo */}
      <div className="flex items-center gap-3 px-2 mb-8">
        <AppLogo size={36} />
        <span className="text-xl font-extrabold text-primary tracking-tight">Nongki</span>
      </div>

      {/* Location Indicator */}
      <div className="flex items-center gap-2 px-3 py-2 bg-secondary rounded-xl mb-6">
        <span className="text-base">📍</span>
        <span className="text-sm font-600 text-primary">Malang, Jawa Timur</span>
      </div>

      {/* Nav Items */}
      <nav className="flex-1 flex flex-col gap-1">
        <p className="text-xs font-600 text-muted-foreground uppercase tracking-widest px-3 mb-2">Menu</p>
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = currentPath === item.href;
          return (
            <Link
              key={`nav-${item.href}`}
              href={item.href}
              className={`sidebar-link ${isActive ? 'active' : ''}`}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </Link>
          );
        })}

        <div className="my-4 border-t border-border" />
        <p className="text-xs font-600 text-muted-foreground uppercase tracking-widest px-3 mb-2">Lainnya</p>
        <Link href="#" className="sidebar-link">
          <Bell size={18} />
          <span>Notifikasi</span>
          <span className="ml-auto bg-accent text-accent-foreground text-xs font-700 px-2 py-0.5 rounded-full">3</span>
        </Link>
        <Link href="#" className="sidebar-link">
          <Settings size={18} />
          <span>Pengaturan</span>
        </Link>
      </nav>

      {/* Auth CTA */}
      <div className="mt-auto pt-4 border-t border-border">
        <Link
          href="/sign-up-login-screen"
          className="btn-primary w-full justify-center text-sm"
        >
          <LogIn size={16} />
          Masuk / Daftar
        </Link>
        <p className="text-xs text-muted-foreground text-center mt-3">
          Login untuk save & review tempat favoritmu
        </p>
      </div>
    </aside>
  );
}